import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-over-query-limit-dialog',
    templateUrl: './over-query-limit-dialog.html',
})
export class OverQueryLimitDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<OverQueryLimitDialogComponent>,
        public loc: LocalizationService,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/over-query-limit-dialog/over-query-limit-dialog.ts